import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { Button, Form, FormGroup, Input } from "reactstrap";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { useKycStatus, useKycCompleted } from "helpers/custom-hooks";
import { useNavigate, } from "react-router-dom";

import GoogleTranslate from "Component/Common/GoogleTranslater";
import useToastr from "helpers/toastr";
import { useLocation } from 'react-router-dom';


import Eng from "../../assets/images/eng.png"
import Arb from "../../assets/images/arb.png"
import { getProfile } from "store/actions";
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton'


// images

export default function Header() {
  const [nav, setNav] = useState(false);
  const { user } = useSelector(({ Login }) => Login);
  const isVerified = useKycStatus();
  const kycCompleted = useKycCompleted();

  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const pathName = location.pathname.substring(1);

  const { settingInfo, loading } = useSelector(({ Settings }) => Settings);


  let ele = document.getElementsByClassName("App");
  useEffect(() => {
    if (nav) {
      ele[0].classList.add("mystyle");
    } else {
      ele[0].classList.remove("mystyle");
    }
  }, [nav]);




  let lang = localStorage.getItem('lang')

  const toastr = useToastr();



  const [isLanguage, setLanguage] = useState(lang || "en");

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 50);
    });
  }, []);






  /**
      * Used for logout the user
      */
  const logout = () => {

    const langObj = localStorage.getItem("lang");
    localStorage.clear();
    window.reload();
    localStorage.setItem('lang', langObj);


  };




  /**
      * Used for handled the tabs on the bases of kyc and auth
      */
  const handleNav = (e, route) => {
    e.preventDefault();

    if (user?.Token && isVerified) {
      navigate(route)
    }
    if (isVerified) {
      setNav(false)
    } else if (user?.Token && !isVerified) {
      toastr.error(t('complete_kyc_first'))
    } else if (user?.Token && kycCompleted =="pending") {
      toastr.error(t('wait_kyc'))
    } else {
      toastr.error(t('login_to_access'), "left")
      navigate('/signin')
    }
  }


  const changeLanguage = (lng) => {
    setLanguage(lng)
    changeLangFunction(lng)

  };


  useEffect(() => {

    const callBack = (response) => {
      if (response.status == "success") {

      }
    }
    if (user?._id) {
      dispatch(getProfile({ id: user?._id }, callBack))

    }


  }, [])

  /**
      * Used for change the language 
      */
  const changeLangFunction = (obj) => {

    if (obj == "ar") {
      window.location.reload();
      localStorage.setItem("lang", "ar")
      i18n.changeLanguage("ar");
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      window.location.reload();
      localStorage.setItem("lang", "en")
      i18n.changeLanguage("en");
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }

  }

  /**
      * Used for render the UI of header
      */
  return (
    <>
      <section className={scroll ? "header-main  fixed-header" : "header-main"}>
        <Container >
          <div className="header">
            <nav class="navbar navbar-expand-lg">
              <div class="container-fluid">
                <Link to="/" class="navbar-brand">
                  {
                    loading ? <Skeleton width={"80%"} height={28} /> : <img src={settingInfo?.logo} alt="logo" className="img-fluid" />
                  }

                </Link>


                <button
                  class="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                  onClick={() => setNav(!nav)}
                >
                  <span className="bar"></span>
                  <span className="bar"></span>
                  <span className="bar"></span>
                </button>

                <div
                  class={
                    nav
                      ? "collapse navbar-collapse show"
                      : "collapse navbar-collapse"
                  }
                  id="navbarSupportedContent"
                >
                  <div className="mobileMenu_overlay" onClick={() => setNav(false)}></div>
                  <ul class="navbar-nav scroll-menu ms-auto mb-2 mb-lg-0">
                    <Button
                      onClick={() => setNav(false)}
                      className="close-menu"
                    >
                      <svg
                        aria-hidden="true"
                        role="img"
                        class="iconify iconify--gg"
                        width="28"
                        height="28"
                        preserveAspectRatio="xMidYMid meet"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill="#560ab5"
                          d="M6.225 4.811a1 1 0 0 0-1.414 1.414L10.586 12L4.81 17.775a1 1 0 1 0 1.414 1.414L12 13.414l5.775 5.775a1 1 0 0 0 1.414-1.414L13.414 12l5.775-5.775a1 1 0 0 0-1.414-1.414L12 10.586L6.225 4.81Z"
                        />
                      </svg>
                    </Button>
                    {
                      user?.Token &&
                      <li className="nav-item">
                        <NavLink
                          to="portfolio"
                          className="nav-link gradient-text"
                          aria-current="page"
                          onClick={(e) => handleNav(e, '/portfolio')}
                        >
                          {t('portfolio')}

                        </NavLink>
                      </li>
                    }
                    <li className="nav-item">
                      <NavLink
                        to="buy"
                        className="nav-link gradient-text"
                        aria-current="page"
                        onClick={(e) => handleNav(e, '/buy')}
                      >
                        {t('buy')}

                      </NavLink>
                    </li>

                    <li className="nav-item">
                      <NavLink to="/sell-crypto" className="nav-link gradient-text"
                        onClick={(e) => handleNav(e, '/sell-crypto')}

                      >

                        {t('sell')}
                      </NavLink>
                    </li>

                    {/* <li className="nav-item">
                      <NavLink to="defiswap" className="nav-link gradient-text" onClick={handleNav}>
                        DeFi Swap
                      </NavLink>
                    </li> */}
                  </ul>
                </div>
              </div>
            </nav>

            <div className="add-wallet-wrap d-flex justify-content-between">

              {
                !user?.Token &&
                <div className="wallet-section">
                  <Link to="/signup" className="nav-link signup_btn">
                    {t('signUp')}

                  </Link>
                  <Link to="/signin" className="nav-link sigb-up-link">
                    {t('logIn')}
                  </Link>
                </div>
              }


              <div className="language_wrap_div d-flex align-items-center gap-4">
                <div className="user_login">
                  <div className="Explore_menu">
                    <UncontrolledDropdown>
                      <DropdownToggle>
                        <div className="language_wrap">
                          {/* <svg viewBox="0 0 24 24" fill="#000" xmlns="http://www.w3.org/2000/svg" role="img" focusable="false" aria-hidden="true" height="22" class="globe-icon container-30myhr eetklgm0"><path fill-rule="evenodd" clip-rule="evenodd" fill="#000" d="M1.011 11.5a11.192 11.192 0 0 0 0 1c.251 5.61 4.706 10.128 10.29 10.478a11.235 11.235 0 0 0 1.398 0c5.584-.35 10.039-4.867 10.29-10.478a11.058 11.058 0 0 0 0-1c-.251-5.61-4.706-10.128-10.29-10.478a11.166 11.166 0 0 0-1.398 0C5.717 1.372 1.262 5.889 1.011 11.5zm1.001 1c.235 4.76 3.797 8.645 8.41 9.376a18.69 18.69 0 0 1-1.104-1.687c-1.096-1.887-2.202-4.543-2.31-7.689H2.013zm4.997-1H2.012c.235-4.76 3.797-8.645 8.41-9.376a18.69 18.69 0 0 0-1.104 1.687C8.222 5.698 7.116 8.353 7.008 11.5zm1 0h7.982c-.107-2.918-1.135-5.399-2.173-7.186a17.648 17.648 0 0 0-1.599-2.312 10.185 10.185 0 0 0-.438 0l-.095.116a17.648 17.648 0 0 0-1.504 2.196C9.144 6.1 8.116 8.582 8.01 11.5zm0 1h7.982c-.107 2.918-1.135 5.399-2.173 7.186a17.642 17.642 0 0 1-1.599 2.312 9.994 9.994 0 0 1-.438 0l-.095-.117a17.642 17.642 0 0 1-1.504-2.195C9.144 17.9 8.116 15.418 8.01 12.5zm5.57 9.376c4.612-.732 8.174-4.616 8.409-9.376H16.99c-.107 3.146-1.213 5.802-2.309 7.689a18.955 18.955 0 0 1-1.103 1.687zM16.99 11.5h4.997c-.235-4.76-3.797-8.645-8.41-9.376.341.464.723 1.03 1.104 1.687 1.096 1.887 2.202 4.542 2.31 7.689z"></path></svg> */}

                          <img src={isLanguage == "en" ? Eng : Arb} className="img-fluid" alt="" />

                        </div>
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem disabled={isLanguage == "en" && true} onClick={() => changeLanguage('en')}>
                          <Link to="#" >
                            <div className="country_icon">
                              <img src={Eng} className="img-fluid" alt="" />
                            </div>
                            English
                          </Link>
                        </DropdownItem>

                        <DropdownItem divider />
                        <DropdownItem disabled={isLanguage == "ar" && true} onClick={() => changeLanguage('ar')}>
                          <Link to="#" >
                            <div className="country_icon">

                              <img src={Arb} className="img-fluid" alt="" />
                            </div>

                            عربي
                          </Link>
                        </DropdownItem>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </div>
                </div>

                {
                  user?.Token &&
                  <div className="user_login">

                    <div className="Explore_menu">
                      <UncontrolledDropdown>
                        <DropdownToggle className="p-0">
                          {
                            user?.profileImage?.link ? <img src={user?.profileImage?.link} alt="profile-img" />
                              :
                              <div className="user_wrap">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="42"
                                  height="42"
                                  viewBox="0 0 42 42"
                                  fill="none"
                                >
                                  <path
                                    d="M21 22.3125C19.4425 22.3125 17.9199 21.8506 16.6249 20.9853C15.3298 20.12 14.3205 18.8901 13.7245 17.4511C13.1284 16.0122 12.9725 14.4288 13.2763 12.9012C13.5802 11.3736 14.3302 9.97038 15.4315 8.86904C16.5329 7.7677 17.9361 7.01768 19.4637 6.71382C20.9913 6.40996 22.5747 6.56591 24.0136 7.16195C25.4526 7.75799 26.6825 8.76735 27.5478 10.0624C28.4131 11.3574 28.875 12.88 28.875 14.4375C28.875 16.5261 28.0453 18.5291 26.5685 20.006C25.0916 21.4828 23.0886 22.3125 21 22.3125ZM21 9.1875C19.9617 9.1875 18.9466 9.49541 18.0833 10.0723C17.2199 10.6492 16.547 11.4691 16.1496 12.4284C15.7523 13.3877 15.6483 14.4433 15.8509 15.4617C16.0535 16.4801 16.5535 17.4156 17.2877 18.1498C18.0219 18.884 18.9574 19.3841 19.9758 19.5866C20.9942 19.7892 22.0498 19.6852 23.0091 19.2879C23.9684 18.8905 24.7883 18.2176 25.3652 17.3542C25.9421 16.4909 26.25 15.4759 26.25 14.4375C26.25 13.0451 25.6969 11.7098 24.7123 10.7252C23.7277 9.74063 22.3924 9.1875 21 9.1875Z"
                                    fill="#560AB5"
                                  />
                                  <path
                                    d="M20.9998 40.6876C18.0893 40.6857 15.2154 40.0384 12.585 38.7925C9.95464 37.5465 7.63325 35.7328 5.78797 33.482L5.10547 32.642L5.78797 31.8151C7.63481 29.5672 9.95689 27.7566 12.5872 26.5134C15.2175 25.2703 18.0906 24.6255 20.9998 24.6255C23.9091 24.6255 26.7822 25.2703 29.4125 26.5134C32.0428 27.7566 34.3649 29.5672 36.2117 31.8151L36.8942 32.642L36.2117 33.482C34.3664 35.7328 32.045 37.5465 29.4147 38.7925C26.7843 40.0384 23.9104 40.6857 20.9998 40.6876ZM8.54422 32.6551C10.1405 34.364 12.0711 35.7265 14.216 36.6581C16.3609 37.5896 18.6745 38.0703 21.013 38.0703C23.3515 38.0703 25.665 37.5896 27.8099 36.6581C29.9549 35.7265 31.8854 34.364 33.4817 32.6551C31.8854 30.9462 29.9549 29.5837 27.8099 28.6522C25.665 27.7206 23.3515 27.2399 21.013 27.2399C18.6745 27.2399 16.3609 27.7206 14.216 28.6522C12.0711 29.5837 10.1405 30.9462 8.54422 32.6551Z"
                                    fill="#560AB5"
                                  />
                                  <path
                                    d="M21 40.6875C16.5279 40.6905 12.1881 39.1709 8.69486 36.3787C5.20158 33.5866 2.76297 29.6884 1.78041 25.3256C0.797848 20.9629 1.32988 16.3956 3.28894 12.3755C5.248 8.35542 8.51735 5.12209 12.5589 3.20768C16.6004 1.29327 21.1733 0.811856 25.5249 1.84268C29.8765 2.87351 33.7475 5.35514 36.5008 8.87914C39.254 12.4031 40.7255 16.7595 40.673 21.2312C40.6205 25.7029 39.0471 30.0235 36.2118 33.4819C34.3665 35.7327 32.0452 37.5464 29.4148 38.7924C26.7844 40.0383 23.9105 40.6856 21 40.6875ZM21 3.93751C17.6253 3.93751 14.3265 4.93821 11.5205 6.81306C8.71463 8.68791 6.52769 11.3527 5.23627 14.4705C3.94485 17.5882 3.60695 21.0189 4.26531 24.3287C4.92367 27.6385 6.54872 30.6788 8.93495 33.065C11.3212 35.4513 14.3614 37.0763 17.6712 37.7347C20.981 38.393 24.4117 38.0551 27.5295 36.7637C30.6473 35.4723 33.3121 33.2853 35.1869 30.4794C37.0618 27.6735 38.0625 24.3747 38.0625 21C38.0625 16.4748 36.2648 12.1348 33.065 8.935C29.8651 5.73516 25.5252 3.93751 21 3.93751Z"
                                    fill="#560AB5"
                                  />
                                  <path
                                    d="M6.79883 32.655C6.79883 32.655 20.0157 47.4206 33.4688 34.125L35.2013 32.655C35.2013 32.655 23.9663 21 12.5607 27.9956L6.79883 32.655Z"
                                    fill="#560AB5"
                                  />
                                  <path
                                    d="M21 21C24.6244 21 27.5625 18.0619 27.5625 14.4375C27.5625 10.8131 24.6244 7.875 21 7.875C17.3756 7.875 14.4375 10.8131 14.4375 14.4375C14.4375 18.0619 17.3756 21 21 21Z"
                                    fill="#560AB5"
                                  />
                                </svg>
                              </div>
                          }

                        </DropdownToggle>

                        <DropdownMenu>
                          <DropdownItem>
                            <Link to="/profile">

                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024"><path fill="#6D7997" d="M512 512a192 192 0 1 0 0-384a192 192 0 0 0 0 384zm0 64a256 256 0 1 1 0-512a256 256 0 0 1 0 512zm320 320v-96a96 96 0 0 0-96-96H288a96 96 0 0 0-96 96v96a32 32 0 1 1-64 0v-96a160 160 0 0 1 160-160h448a160 160 0 0 1 160 160v96a32 32 0 1 1-64 0z" /></svg>

                              {t('profile')}
                            </Link>
                          </DropdownItem>

                          <DropdownItem>
                            <Link to="/kyc">
                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024"><path fill="#6D7997" d="M832 384H576V128H192v768h640V384zm-26.496-64L640 154.496V320h165.504zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32zm160 448h384v64H320v-64zm0-192h160v64H320v-64zm0 384h384v64H320v-64z" /></svg>
                              {t('kyc')}
                            </Link>
                          </DropdownItem>


                          {
                            isVerified  &&
                            <DropdownItem>
                              <Link to="/buy-sell-history">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"><path fill="#6D7997" fill-rule="evenodd" d="M9.1 2.398a.75.75 0 0 1-.43.97a9.187 9.187 0 0 0-.42.173a.75.75 0 1 1-.608-1.37c.16-.072.323-.14.488-.203a.75.75 0 0 1 .97.43ZM5.648 4.24a.75.75 0 0 1-.026 1.06a9.31 9.31 0 0 0-.321.322a.75.75 0 1 1-1.087-1.035c.122-.127.246-.251.373-.373a.75.75 0 0 1 1.06.026ZM3.16 7.261a.75.75 0 0 1 .381.99c-.061.138-.12.278-.174.419a.75.75 0 0 1-1.399-.54c.063-.165.13-.327.202-.488a.75.75 0 0 1 .99-.381Zm-1.139 3.743a.75.75 0 0 1 .732.768a9.448 9.448 0 0 0 0 .456a.75.75 0 0 1-1.5.036a10.961 10.961 0 0 1 0-.528a.75.75 0 0 1 .768-.732ZM21.603 14.9a.75.75 0 0 1 .429.97c-.064.165-.13.327-.202.488a.75.75 0 1 1-1.371-.609a9.28 9.28 0 0 0 .174-.419a.75.75 0 0 1 .97-.43Zm-19.205 0a.75.75 0 0 1 .97.43c.054.141.112.281.173.42a.75.75 0 1 1-1.37.608a9.104 9.104 0 0 1-.203-.488a.75.75 0 0 1 .43-.97Zm17.362 3.452c.3.286.311.76.026 1.06a11.96 11.96 0 0 1-.373.374a.75.75 0 1 1-1.035-1.087c.11-.104.217-.211.321-.32a.75.75 0 0 1 1.06-.027Zm-15.52 0a.75.75 0 0 1 1.06.026c.105.11.212.217.322.321a.75.75 0 1 1-1.035 1.087a10.788 10.788 0 0 1-.373-.373a.75.75 0 0 1 .026-1.06Zm3.021 2.488a.75.75 0 0 1 .99-.381c.138.061.278.12.419.174a.75.75 0 0 1-.54 1.399a10.61 10.61 0 0 1-.488-.202a.75.75 0 0 1-.381-.99Zm9.478 0a.75.75 0 0 1-.381.99c-.16.071-.323.139-.488.202a.75.75 0 1 1-.54-1.4a9.28 9.28 0 0 0 .42-.173a.75.75 0 0 1 .989.381Zm-5.735 1.139a.75.75 0 0 1 .768-.732a9.101 9.101 0 0 0 .456 0a.75.75 0 0 1 .036 1.5a11.065 11.065 0 0 1-.528 0a.75.75 0 0 1-.732-.768ZM11.25 2a.75.75 0 0 1 .75-.75c5.937 0 10.75 4.813 10.75 10.75a.75.75 0 0 1-1.5 0A9.25 9.25 0 0 0 12 2.75a.75.75 0 0 1-.75-.75ZM12 8.25a.75.75 0 0 1 .75.75v3.25H16a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 1-.75-.75V9a.75.75 0 0 1 .75-.75Z" clip-rule="evenodd" /></svg>
                                {t('history')}
                              </Link>
                            </DropdownItem>
                          }

                          {

                            <DropdownItem>
                              <Link to="/favourites">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                  <path d="M11.125 2C9.83438 2 8.70438 2.555 8 3.49312C7.29562 2.555 6.16562 2 4.875 2C3.84764 2.00116 2.86269 2.40979 2.13624 3.13624C1.40979 3.86269 1.00116 4.84764 1 5.875C1 10.25 7.48687 13.7913 7.76312 13.9375C7.83594 13.9767 7.91732 13.9972 8 13.9972C8.08268 13.9972 8.16406 13.9767 8.23687 13.9375C8.51312 13.7913 15 10.25 15 5.875C14.9988 4.84764 14.5902 3.86269 13.8638 3.13624C13.1373 2.40979 12.1524 2.00116 11.125 2ZM8 12.925C6.85875 12.26 2 9.23062 2 5.875C2.00099 5.11281 2.30421 4.38212 2.84316 3.84316C3.38212 3.30421 4.11281 3.00099 4.875 3C6.09063 3 7.11125 3.6475 7.5375 4.6875C7.57517 4.77921 7.63925 4.85764 7.7216 4.91284C7.80396 4.96804 7.90086 4.99752 8 4.99752C8.09914 4.99752 8.19604 4.96804 8.2784 4.91284C8.36075 4.85764 8.42483 4.77921 8.4625 4.6875C8.88875 3.64562 9.90937 3 11.125 3C11.8872 3.00099 12.6179 3.30421 13.1568 3.84316C13.6958 4.38212 13.999 5.11281 14 5.875C14 9.22563 9.14 12.2594 8 12.925Z" fill="#6D7997" />
                                </svg>
                                {t('favourites')}
                              </Link>
                            </DropdownItem>
                          }

                          {

                            <DropdownItem>
                              <Link to="/blogs">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 1024 1024"><path fill="#6D7997" d="M832 384H576V128H192v768h640V384zm-26.496-64L640 154.496V320h165.504zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32zm160 448h384v64H320v-64zm0-192h160v64H320v-64zm0 384h384v64H320v-64z" /></svg>
                                {t('blogs')}
                              </Link>
                            </DropdownItem>
                          }
                          <DropdownItem>
                            <Link to="/" onClick={logout}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                              >
                                <path
                                  d="M3.33333 14C2.96667 14 2.65267 13.8693 2.39133 13.608C2.13 13.3467 1.99956 13.0329 2 12.6667V3.33333C2 2.96667 2.13067 2.65267 2.392 2.39133C2.65333 2.13 2.96711 1.99956 3.33333 2H8V3.33333H3.33333V12.6667H8V14H3.33333ZM10.6667 11.3333L9.75 10.3667L11.45 8.66667H6V7.33333H11.45L9.75 5.63333L10.6667 4.66667L14 8L10.6667 11.3333Z"
                                  fill="#6D7997"
                                />
                              </svg>
                              {t('logout')}
                            </Link>
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </div>
                }
              </div>

            </div>
          </div>
        </Container>
      </section>
    </>
  );
}
